import { memoize } from "lodash";

export const getScrollbarWidth = memoize((): number => {
  const outer = document.createElement("div");
  outer.style.visibility = "hidden";
  outer.style.overflow = "scroll";
  document.body.appendChild(outer);

  const inner = document.createElement("div");
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  if (outer.parentNode && document.body.contains(outer)) {
    outer.parentNode.removeChild(outer);
  }

  return scrollbarWidth;
});
